"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createD2CMessage = exports.createC2DMessage = void 0;
const effect_1 = require("effect");
const common_1 = require("../common");
const message_1 = require("./message");
const createGetConsumablesCommand = (namespace) => (0, message_1.createMessage)('command', effect_1.Schema.Struct({ command: effect_1.Schema.tag('consumables.get') })).annotations({
    identifier: `${namespace}.Get`,
});
const createC2DMessage = (namespace, slots, catalogue) => effect_1.Schema.Union((0, message_1.createMessage)('consumable', effect_1.Schema.Union(common_1.Consumable.createCatalogueMessage(namespace, catalogue), common_1.Consumable.createUpdateConsumableMessage(namespace, slots))), createGetConsumablesCommand(namespace)).annotations({
    identifier: `${namespace}.ConsumableC2DMessage`,
    description: 'A Cloud-To-Device message related to consumables',
});
exports.createC2DMessage = createC2DMessage;
const createD2CMessage = (namespace, slots) => (0, message_1.createMessage)('consumable', effect_1.Schema.Union(common_1.Consumable.createRequestCatalogueMessage(namespace), common_1.Consumable.createStateMessage(namespace, slots))).annotations({
    identifier: `${namespace}.ConsumableD2CMessage`,
    title: 'Consumable Message',
    description: 'A Device-To-Cloud message on the "consumable" channel',
});
exports.createD2CMessage = createD2CMessage;
//# sourceMappingURL=consumable.js.map